// extracted by mini-css-extract-plugin
module.exports = {"Input":"UserReports_Input__2HXm4","ReportItem":"UserReports_ReportItem__2bB2S"};